import defaultState from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const hailState = {
  namespaced: true,
  state: {
    ...defaultState,
  },
  getters,
  mutations,
  actions,
}

export default hailState



// WEBPACK FOOTER //
// ./src/store/hailState/index.js